export enum ChartType {
  LINE = 'LINE',
  SCATTER = 'SCATTER',
  COLUMN = 'COLUMN',
  BAR = 'BAR',
  AREA = 'AREA',
  PIE = 'PIE',
}
